<template>
    <div class="intranet-filter-search" role="search">
        <div class="search-text">
            <input ref="input" :placeholder="placeholder" type="text" :value="inputValue" class="search-text-input" v-debounce:[debounce]="update"
                :aria-label="ariaLabel" v-on="events" spellcheck="false" v-focus="autofocus"/>
        </div>

        <div v-if="inputValue" class="search-icon pointer" title="Eingabe leeren" v-interact="clear">
            <i class="material-icons" aria-hidden="true" role="img">close</i>
        </div>
        <div v-else class="search-icon">
            <i class="material-icons" aria-hidden="true" role="img">search</i>
        </div>
    </div>
</template>

<script setup lang="ts">
    import {usePortuna} from '@/composables/portuna';
    import {ref, nextTick, watch} from 'vue';

    const portuna    = usePortuna();
    const emit       = defineEmits<{
        'update:modelValue': [newValue: string];
    }>();
    const props      = withDefaults(
        defineProps<{
            modelValue?: string;
            debounce?: string;
            placeholder?: string;
            ariaLabel?: string;
            autofocus?: boolean;
            events?: object;
        }>(),
        {
            modelValue: '',
            placeholder: 'Suchbegriff',
            ariaLabel: '',
            autofocus: false,
            events: () => ({}),
        },
    );
    const input      = ref<HTMLInputElement>();
    const inputValue = ref<string>('');
    inputValue.value = props.modelValue;
    portuna.emitter.on('input', (value: string) =>
    {
        inputValue.value = value;
    });
    const focus      = () =>
    {
        input.value?.focus();
    };
    const watchValue = (newValue: string) =>
    {
        inputValue.value = newValue;
    };
    const update     = (newValue: string) =>
    {
        inputValue.value = newValue;
        emit('update:modelValue', newValue);
    };
    const clear      = () =>
    {
        update('');
        nextTick().then(focus);
    };
    watch(() => props.modelValue, watchValue);
    defineExpose(Object.assign(portuna, {focus}));
</script>